module.exports = __webpack_public_path__ + "img/pet_bostie.902b810c.svg";